/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Servicenow_Fe_IdInputs */

const en_user_servicenow_fe_id = /** @type {(inputs: User_Servicenow_Fe_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow ID`)
};

const ja_user_servicenow_fe_id = /** @type {(inputs: User_Servicenow_Fe_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow ID`)
};

const fr_user_servicenow_fe_id = /** @type {(inputs: User_Servicenow_Fe_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ServiceNow`)
};

const de_user_servicenow_fe_id = /** @type {(inputs: User_Servicenow_Fe_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow-ID`)
};

/**
* | output |
* | --- |
* | "ServiceNow ID" |
*
* @param {User_Servicenow_Fe_IdInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_servicenow_fe_id = /** @type {((inputs?: User_Servicenow_Fe_IdInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Servicenow_Fe_IdInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_servicenow_fe_id(inputs)
	if (locale === "ja") return ja_user_servicenow_fe_id(inputs)
	if (locale === "fr") return fr_user_servicenow_fe_id(inputs)
	return de_user_servicenow_fe_id(inputs)
});